const selectors = {
  block: "[data-process-flow]",
  items: "[data-process-flow-item]",
  details: "[data-process-flow-detail]",
  buttons: "[data-process-flow-button]",
};

const elements = {
  block: null,
  items: null,
  details: null,
  buttons: null,
};

const classes = {
  active: "active",
  hidden: "hidden",
  disabled: "disabled",
};

const BUTTON_TYPES = {
  NEXT: "next",
  PREV: "prev",
};

let ACTIVE_PROCESS_FLOW_INDEX = 0;

function handleNavigateClick({ currentTarget }) {
  const buttonType = currentTarget.getAttribute("data-process-flow-button");
  elements.items.forEach((item) => item.classList.remove(classes.active));
  elements.details.forEach((detail) => detail.classList.add(classes.hidden));

  if (buttonType === BUTTON_TYPES.NEXT) {
    ++ACTIVE_PROCESS_FLOW_INDEX;
  }

  if (buttonType === BUTTON_TYPES.PREV) {
    --ACTIVE_PROCESS_FLOW_INDEX;
  }

  if (ACTIVE_PROCESS_FLOW_INDEX === elements.items.length - 1) {
    elements.buttons[1].setAttribute(classes.disabled, "");
  } else {
    elements.buttons[1].removeAttribute(classes.disabled);
  }

  if (ACTIVE_PROCESS_FLOW_INDEX === 0) {
    elements.buttons[0].setAttribute(classes.disabled, "");
  } else {
    elements.buttons[0].removeAttribute(classes.disabled);
  }

  elements.items[ACTIVE_PROCESS_FLOW_INDEX].classList.add(classes.active);
  elements.details[ACTIVE_PROCESS_FLOW_INDEX].classList.remove(classes.hidden);

  elements.items[ACTIVE_PROCESS_FLOW_INDEX].scrollIntoView({
    behavior: "smooth",
    block: "nearest",
    inline: "center",
  });
}

const init = () => {
  elements.block = document.querySelector(selectors.block);
  elements.items = Array.from(document.querySelectorAll(selectors.items) || []);
  elements.details = Array.from(document.querySelectorAll(selectors.details) || []);
  elements.buttons = Array.from(document.querySelectorAll(selectors.buttons) || []);

  if (!elements.block) return null;

  elements.buttons.forEach((button) => button.addEventListener("click", handleNavigateClick));
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    init();
  },
  {
    once: true,
  }
);
